export type WorkbenchTheme = 'light' | 'dark';

export const MERCEDES_BENZ_LIGHT: WorkbenchTheme = 'light';
export const MERCEDES_BENZ_DARK: WorkbenchTheme = 'dark';

export const DEFAULT_WORKBENCH_THEME: WorkbenchTheme = MERCEDES_BENZ_LIGHT;

/**
 * This function sets the `data-on` attribute on the given element based on the current value and a given (deprecated)
 * theme. It exists for retro-compatibility reasons and should be removed on the next major version.
 *
 * DEFER TODO: Remove this function on the next major version.
 */
export const getDataOnFromTheme = (el: HTMLElement, theme?: WorkbenchTheme): string | undefined => {
  if (el.hasAttribute('data-on')) {
    return el.getAttribute('data-on');
  }
  const bodyDataBrand = document.body.getAttribute('data-brand');
  if (theme === MERCEDES_BENZ_LIGHT) {
    return bodyDataBrand === 'amg' ? 'contrast' : 'main';
  }
  if (theme === MERCEDES_BENZ_DARK) {
    return bodyDataBrand === 'amg' ? 'main' : 'contrast';
  }
  return undefined;
};
